<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <localgovernment-form></localgovernment-form>
      </div>
    </div>
  </div>
</template>

<script>
import LocalgovernmentForm from "@/views/localgov/components/Form.vue";

export default {
  name: "add-localgovernment",
  components: {
    LocalgovernmentForm,
  }
};
</script>